import { Injectable } from '@angular/core'
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http'
import { map } from 'rxjs/operators'
import { Observable } from 'rxjs'
import { PATH } from '../app.api'
import { Evaluation } from '../models/Evaluation'
import {
	IHandlerOperation,
	IHandlerOperationAndMonitoring,
	IManagementConfiguration,
	Section
} from '../models/HandlerOperation'

@Injectable()
export class HandlerOperationService {
	constructor(private http: HttpClient) {}

	public get(id: string): Observable<IHandlerOperation> {
		const options: any = this.setHeader()

		return this.http
			.get<any>(`${PATH}/handlerOperation/${id}`, { headers: options })
			.pipe(
				map(result => {
					return result.content
				})
			)
	}

	public list(
		companyId: string,
		isManagementConfiguration: boolean,
		app?: 'Evaluator' | 'Inventor' | 'Planting'
	): Observable<Array<IHandlerOperation>> {
		let params = new HttpParams()

		params =
			params.set('isManagementConfiguration', isManagementConfiguration.toString())

		if (app) {
			params = params.set('app', app)
		}

		const options = { headers: this.setHeader(), params }

		return this.http
			.get<any>(`${PATH}/handlerOperation/list/${companyId}`, options)
			.pipe(
				map(result => {
					return result.content
				})
			)
	}

	public create(handlerOperation: IHandlerOperation): Observable<any> {
		const options: any = this.setHeader()

		return this.http.post<any>(
			`${PATH}/handlerOperation`,
			JSON.stringify(handlerOperation),
			{
				headers: options
			}
		)
	}

	public edit(handlerOperation: IHandlerOperation): Observable<any> {
		const options: any = this.setHeader()

		return this.http.patch<any>(
			`${PATH}/handlerOperation/${handlerOperation._id}`,
			JSON.stringify(handlerOperation),
			{
				headers: options
			}
		)
	}

	public delete(id: string): Observable<any> {
		const options: any = this.setHeader()

		return this.http.delete<any>(`${PATH}/handlerOperation/${id}`, {
			headers: options
		})
	}

	public obsolete(id: string): Observable<string> {
		const options: any = this.setHeader()

		return this.http.patch<any>(`${PATH}/handlerOperation/obsolete/${id}`, {
			headers: options
		}).pipe(
			map(result => {
				return result.message
			})
		)
	}

	private setHeader(): any {
		const headers: any = new HttpHeaders({
			'Content-Type': 'application/json'
		})
		const options: any = headers

		return options
	}

	/**
	 * CONFIGURAÇÃO DE MANEJO
	 */
	public setManagementConfiguration(
		handlerOperationId: string,
		managementConfiguration: IManagementConfiguration
	): Observable<any> {
		const options: any = this.setHeader()

		return this.http.patch<any>(
			`${PATH}/handlerOperation/managementConfiguration/${handlerOperationId}`,
			JSON.stringify(managementConfiguration),
			{
				headers: options
			}
		)
	}

	public getMonitoringManagementConfiguration(companyId: string): Observable<IHandlerOperationAndMonitoring> {
		const options: any = this.setHeader()

		return this.http
			.get<any>(
				`${PATH}/handlerOperation/managementConfiguration/monitoring/${companyId}`,
				{ headers: options }
			)
			.pipe(
				map(result => {
					return result.content
				})
			)
	}

	public getSpecialRecommendations(): Observable<Array<{value: string, label: string}>> {
		const options: any = this.setHeader()

		return this.http
			.get<any>(
				`${PATH}/handlerOperation/special/recommendations`,
				{ headers: options }
			)
			.pipe(
				map(result => {
					return result.content
				})
			)
	}

	public getTypeOperations(): Observable<Array<{value: string, label: string}>> {
		const options: any = this.setHeader()

		return this.http
			.get<any>(
				`${PATH}/handlerOperation/type/operations`,
				{ headers: options }
			)
			.pipe(
				map(result => {
					return result.content
				})
			)
	}

	public createSection(section: Section): Observable<string> {
		const options: any = this.setHeader()

		return this.http.post<any>(
			`${PATH}/handlerOperation/section`,
			section,
			{
				headers: options
			}
		).pipe(
			map(result => {
				return result.message
			})
		)
	}

	public editSection(section: Section): Observable<string> {
		const options: any = this.setHeader()

		return this.http.patch<any>(
			`${PATH}/handlerOperation/section`,
			section,
			{
				headers: options
			}
		).pipe(
			map(result => {
				return result.message
			})
		)
	}

	public findSectionsFromHandlerOperation(handlerOperationId: string): Observable<Array<Section>> {
		const options: any = this.setHeader()

		return this.http.get<any>(`${PATH}/handlerOperation/section/${handlerOperationId}`, {headers: options})
			.pipe(
				map(result => {
					return result.content
				})
			)
	}

	public deleteSection(sectionId: number): Observable<string> {
		const options: any = this.setHeader()

		return this.http.delete<any>(`${PATH}/handlerOperation/section/${sectionId}`, {headers: options})
			.pipe(
				map(result => {
					return result.message
				})
			)
	}
}
